import _ from 'underscore';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import Container from 'components/Container';
import Section from 'components/Section';

import styles from './styles.module.scss';

const Catalog = ({
	children,
	controlsTop,
	emptyMessage,
	limit,
	onMoreButtonClick,
	title,
	total,
	visibleTotal,
	isLoading
}) => {
	const enabledMoreButton = total > visibleTotal && limit < total;

	const moreButtonTitle = useMemo(() => {
		const moreText = 'Показать еще';
		if (limit && total && enabledMoreButton) {
			const totalHiddenItems = total - visibleTotal;
			const nextNumberItems =
				totalHiddenItems >= limit ? limit : totalHiddenItems;

			return `${moreText} ${nextNumberItems} из ${totalHiddenItems}`;
		}
		return moreText;
	}, [limit, total, visibleTotal]);

	return (
		<Section title={title}>
			<Container className={styles.Catalog}>
				{controlsTop && (
					<div className={styles.Catalog__ControlsBlock}>{controlsTop}</div>
				)}
				{!_.isEmpty(children) ? (
					<div className={styles.Catalog__Cards}>{children}</div>
				) : (
					<div className={styles.Catalog__EmptyMessage}>{emptyMessage}</div>
				)}
				<div className={styles.Catalog__WrapButton}>
					<Button
						title={moreButtonTitle}
						onClick={enabledMoreButton ? onMoreButtonClick : null}
						width="limited"
						disabled={isLoading || total === 0 || enabledMoreButton !== true}
						isLoading={isLoading}
					/>
				</div>
			</Container>
		</Section>
	);
};

Catalog.propTypes = {
	children: PropTypes.node.isRequired,
	controlsTop: PropTypes.node,
	emptyMessage: PropTypes.string,
	limit: PropTypes.number,
	onMoreButtonClick: PropTypes.func,
	title: PropTypes.string.isRequired,
	total: PropTypes.number,
	visibleTotal: PropTypes.number,
	isLoading: PropTypes.bool
};

Catalog.defaultProps = {
	emptyMessage: 'К сожалению, событий по вашему запросу не найдено',
	isLoading: false
};

export default Catalog;
